export enum RatingValue {
  EMPTY = 0,
  HALF = 0.5,
  FULL = 1
}
